module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/face_positive.8c8bc059.svg";